import { url } from '@tencent/ppd-base-libs';

export function isThirtPart() {
  return !!url.getUrlParam('source');
}
